import React, { useState } from 'react'
// Ant design
import {
  PlusCircleOutlined,
  SmileOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import {
  Button,
  Dropdown,
  Form,
  Image,
  Input,
  Menu,
  Modal,
  Radio,
  Select,
  Space,
  Upload,
  message,
  notification,
} from 'antd'
// Styled Components
import styled from 'styled-components'
import { ImgSignatureDemo } from './CreateSignatureModalStyled'
// Components
import { inject, observer } from 'mobx-react'
import { DIGITAL_SIGN_PROVIDER, DIGITAL_TYPE_SIGN } from '../../../constants'
import SignatureCanvasModal from './SignatureCanvasModal/SignatureCanvasModal'
import { blue } from '../../../color'

const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    min-height: 300px;
    background-color: #e3edf7;
    border-radius: 16px;
  }
  .ant-modal-header {
    background-color: transparent;
    border-bottom: none;
    padding: 24px 24px 16px;
    border-radius: 16px 16px 0 0;
  }
  .ant-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
  .ant-modal-close {
    top: 20px;
    right: 20px;
  }
  .ant-modal-body {
    padding: 0 24px 24px;
  }
`

const TypeSignatureStyle = {
  display: 'inline-block',
  minWidth: 150,
  lineHeight: '35px',
}

const CreateSignatureModal = props => {
  const {
    isCreateSignatureModalVisible,
    handleCloseCreateSignatureModal,
    signedDocumentStore,
    loadingAnimationStore,
    fileStore,
    authenticationStore,
  } = props

  const [typeSignatureActive, setTypeSignatureActive] = useState(null)
  const [imgSignature, setImgSignature] = useState(null)
  const [
    isVisibleSignatureCanvasModal,
    setIsVisibleSignatureCanvasModal,
  ] = useState(false)
  const [fileSignature, setFileSignature] = useState(null)
  const { currentUser } = authenticationStore

  const onChange = e => {
    setTypeSignatureActive(e.target.value)
  }

  const handleCloseModal = () => {
    handleCloseCreateSignatureModal()
    setTypeSignatureActive(null)
  }

  const handleCancelSignatureCanvas = () => {
    setIsVisibleSignatureCanvasModal(false)
  }

  const handleCreatedSuccess = () => {
    refreshList()
  }

  const onChangeUploadImg = file => {
    if (file.file.type !== 'image/png') {
      message.warning('File được chọn phải file ảnh PNG!')
      return
    }
    setFileSignature(file.file)
    const imgBlob = new Blob([file.file], { type: 'image/png' })
    const url_signature = URL.createObjectURL(imgBlob)
    setImgSignature(url_signature)
  }

  const handleCreateSignature = async value => {
    const formData = new FormData()
    formData.append('file', fileSignature, value.signature_name)

    try {
      loadingAnimationStore.showSpinner(true)

      //upload file
      const uploadResponse = await fileStore.uploadFile(formData)
      const fileId = uploadResponse.data.file_id
      const fileName = value.signature_name
      console.log('uploadedFile', fileId)

      //sign
      const data = {
        file_id: fileId,
        file_name: fileName,
        provider: DIGITAL_SIGN_PROVIDER,
        type_sign: DIGITAL_TYPE_SIGN,
        type_signature: selectedSignature,
      }
      const createSignatureBySendFileIdResponse = await signedDocumentStore.createSignatureBySendFileId(
        data
      )
      message.success('Tạo chữ ký thành công')
      refreshList()
    } catch (error) {
      console.log(error)
      message.error(error.vi)
    } finally {
      loadingAnimationStore.showSpinner(false)
      handleCloseCreateSignatureModal()
    }

    setTypeSignatureActive(null)
    setImgSignature(null)
  }

  const handleCreateTextSignature = () => {
    notification.open({
      message: <b>Thông báo</b>,
      description: 'Chưa có chức năng tạo chữ ký văn bản!',
      placement: 'topLeft',
      duration: 2,
      icon: <SmileOutlined style={{ color: '#d63031' }} />,
    })
  }

  const handleCancelCreateImageSignature = () => {
    setTypeSignatureActive(null)
    setImgSignature(null)
  }

  const refreshList = async () => {
    if (currentUser) {
      loadingAnimationStore.showSpinner(true)
      await signedDocumentStore.getSignatureList({
        user_name: currentUser.username,
      })
      loadingAnimationStore.showSpinner(false)
    }
  }

  const [selectedSignature, setSelectedSignature] = useState('MAIN_SIGN') // Default button text

  const handleMenuClick = e => {
    // Set the button text to the selected item
    setSelectedSignature(e)
  }

  const options = [
    {
      value: '',
      label: 'Vui lòng chọn loại chữ ký',
    },
    {
      value: 'FLASH_SIGN',
      label: 'Chữ ký nháy',
    },
    {
      value: 'MAIN_SIGN',
      label: 'Chữ ký chính',
    },
    {
      value: 'CIRCLE_SIGN',
      label: 'Dấu mộc',
    },
  ]

  return (
    <ModalWrapper
      title={'Chọn loại chữ ký'}
      visible={isCreateSignatureModalVisible}
      onCancel={handleCloseModal}
      footer={null}>
      <div style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '12px' }}>
        <Radio.Group onChange={onChange} value={typeSignatureActive} style={{ width: '100%' }}>
          <Space direction="vertical" size={30} style={{ width: '100%' }}>
            <Radio value={1} style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
              <span style={TypeSignatureStyle}>Chữ ký tay</span>
              {typeSignatureActive === 1 && (
                <Button
                  icon={<PlusCircleOutlined />}
                  type={'primary'}
                  style={{ height: 30 }}
                  onClick={() => setIsVisibleSignatureCanvasModal(true)}>
                  Tạo
                </Button>
              )}
            </Radio>
            <Radio value={3} style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
              <span style={TypeSignatureStyle}>Chữ ký hình ảnh</span>
              {typeSignatureActive === 3 && (
                <Upload
                  showUploadList={false}
                  beforeUpload={() => false}
                  onChange={onChangeUploadImg}>
                  <Button
                    icon={<UploadOutlined />}
                    type={'primary'}
                    style={{ height: 30 }}>
                    {imgSignature ? 'Chọn ảnh khác' : 'Chọn ảnh'}
                  </Button>
                </Upload>
              )}
            </Radio>
          </Space>
        </Radio.Group>
      </div>
      {imgSignature && typeSignatureActive === 3 && (
        <ImgSignatureDemo>
          <Form layout="vertical" onFinish={handleCreateSignature}>
            <Form.Item
              label="Tên mẫu chữ ký"
              name="signature_name"
              rules={[{ required: true, message: 'Hãy nhập tên mẫu chữ ký!' }]}>
              <Input placeholder={'Nhập tên mẫu chữ ký'} />
            </Form.Item>
            <Form.Item
              style={{ display: 'none' }}
              name="type_signature"
              label="Loại chữ ký"
              // rules={[{ required: true, message: 'Hãy nhập loại chữ ký!' }]}
            >
              <Select
                value={selectedSignature}
                onChange={handleMenuClick}
                defaultValue={''}>
                <Option value="">
                  <span style={{ color: 'rgba(0,0,0,0.3)' }}>
                    Vui lòng chọn loại chữ ký{' '}
                  </span>
                </Option>
                <Option value="FLASH_SIGN">Chữ ký nháy</Option>
                <Option value="MAIN_SIGN">Chữ ký chính</Option>
                <Option value="CIRCLE_SIGN">Dấu mộc</Option>
              </Select>
            </Form.Item>

            <div className={'img-signature'} style={{ marginTop: '10px' }}>
              <Image src={imgSignature} alt="signature" />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                danger
                style={{ marginRight: 8 }}
                onClick={handleCancelCreateImageSignature}>
                Hủy bỏ
              </Button>
              <Button type={'primary'} htmlType={'submit'}>
                Lưu chữ ký
              </Button>
            </div>
          </Form>
        </ImgSignatureDemo>
      )}
      <SignatureCanvasModal
        isVisibleSignatureCanvasModal={isVisibleSignatureCanvasModal}
        handleCancelSignatureCanvas={handleCancelSignatureCanvas}
        handleCloseCreateSignatureModal={handleCloseCreateSignatureModal}
        handleCreatedSuccess={handleCreatedSuccess}
      />
    </ModalWrapper>
  )
}

CreateSignatureModal.propTypes = {}

export default inject(
  'signedDocumentStore',
  'loadingAnimationStore',
  'fileStore',
  'authenticationStore'
)(observer(CreateSignatureModal))
